import { Icon } from 'components'

import * as S from './styles'

export type NotFoundProps = {
  icon?: React.ReactNode
  title?: string
  description?: string | React.ReactElement
}

export const NotFound: React.FC<NotFoundProps> = ({
  icon = <Icon icon="search-off" size="50" />,
  title,
  description,
}) => {
  return (
    <S.ItemFoundInfoStyled>
      {icon}
      <span data-testid="NotFound-title" id="NoItemFoundTitle">
        {title}
      </span>
      <span data-testid="NotFound-description" id="NoItemFoundDescription">
        {description}
      </span>
    </S.ItemFoundInfoStyled>
  )
}
